import { createStore, sample } from 'effector';
import { spread } from 'patronum';
import { Highroller, receiveTop } from 'shared/api';
import { createModalSwitcher } from 'shared/lib';

const highrollersSwitcher = createModalSwitcher();

const $currency = createStore('');

const $highrollers = createStore<Highroller[]>([]);

sample({
	clock: receiveTop.success,
	target: spread({
		currency: $currency,
		highrollers: $highrollers,
	}),
});

export const highrollersModalModel = {
	highrollersSwitcher,
	$currency,
	$highrollers,
};
